export default function SVG1_1(props: any) {
    return (
        <svg width="31" height="25" viewBox="0 0 31 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.11252 2.71366H22.275C22.275 1.31925 20.9588 0.25293 19.2375 0.25293H3.03751C1.31625 0.25293 0 1.31925 0 2.71366V21.5792C0 22.9737 1.31625 24.04 3.03751 24.04H19.2375C20.9588 24.04 22.275 22.9737 22.275 21.5792V20.759H9.11252C6.88501 20.759 5.06251 19.2826 5.06251 17.478V5.99463C5.06251 4.1901 6.88501 2.71366 9.11252 2.71366ZM28.3485 4.35483H9.11094C7.99719 4.35483 7.08594 5.09304 7.08594 5.99531V17.4787C7.08594 18.381 7.99719 19.1192 9.11094 19.1192H28.3485C29.4622 19.1192 30.3735 18.381 30.3735 17.4787V5.99531C30.3735 5.09304 29.4622 4.35483 28.3485 4.35483Z"
                fill="#18FFAC"
            />
        </svg>
    );
}
